import { render, staticRenderFns } from "./ShowAskOpinion.vue?vue&type=template&id=1c7caf7d&scoped=true&"
import script from "./ShowAskOpinion.vue?vue&type=script&lang=ts&"
export * from "./ShowAskOpinion.vue?vue&type=script&lang=ts&"
import style0 from "./ShowAskOpinion.vue?vue&type=style&index=0&id=1c7caf7d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c7caf7d",
  null
  
)

export default component.exports